import PropTypes from 'prop-types';
import GridOptions from './GridOptions';
import MuiGrid from '../../../../UI/MuiGrid/MuiGrid';
import { icons } from '../../../../../../shared/icons';
import MyButton from '../../../../UI/myButton/MyButton';

const GridProvider = ({
  data,
  handleOpenDeleteDialog,
  handleOpenDialogForm,
  handleOpenDokumenta,
  isLoading,
  naplacujeSe,
}) => {
  const shouldHideColumns = localStorage.sa === 'true';
  const allColumns = [
    {
      field: 'id',
      disableExport: true,
      headerName: 'Opcije',
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDeleteDialog(e.id)}
          handleOpenDokumenta={() => handleOpenDokumenta(e.row)}
          getEditData={() => handleOpenDialogForm(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    { field: 'nazivUsluge', headerName: 'Vrsta', width: 200 },
    // { field: 'naziv', headerName: 'Naziv', width: 400 },
    { field: 'jm', headerName: 'Jedinica mere', width: 120 },
    { field: 'kolicina', headerName: 'Količina', width: 120 },
    { field: 'cena', headerName: 'Iznos troška', width: 190 },
    { field: 'iznos', headerName: 'Cena prema klijentu', width: 200 },
    { field: 'cenaKolicina', headerName: 'Ukupno', width: 200 },
    { field: 'opis', headerName: 'Opis', width: 500 },
  ];
  const columns = allColumns.filter((column) => {
    if (!shouldHideColumns) {
      // Sakrivamo kolone 'brutoCenaZaposlenog' i 'cena' kada je shouldHideColumns false
      if (
        column.field === 'iznos' ||
        column.field === 'cena' ||
        column.field === 'cenaKolicina'
      ) {
        return false;
      }
    }

    // Sakrivamo kolonu 'cena' ako naplacujeSe nije istinito, osim ako shouldHideColumns === true
    if (column.field === 'iznos') {
      if (!naplacujeSe && !shouldHideColumns) {
        return false;
      }
      if (!naplacujeSe && shouldHideColumns) {
        return false;
      }
    }

    return true;
  });
  return (
    <div style={{ height: '52vh', width: '99%' }}>
      <MyButton
        label="Novi unos"
        style={{ marginBottom: '5px' }}
        onClick={() => handleOpenDialogForm({})}
      />
      <MuiGrid data={data} columns={allColumns} loading={isLoading} />
    </div>
  );
};

GridProvider.propTypes = {
  data: PropTypes.array.isRequired,
  handleOpenDeleteDialog: PropTypes.func.isRequired,
  handleOpenDialogForm: PropTypes.func.isRequired,
};

export default GridProvider;
